import React, { useState } from 'react';
import { useAuthentication } from '../authentiction';
import { Alert } from 'react-bootstrap';

const LicenseExpiryWarningNotification: React.FC = () => {
  const { showNagScreen, daysUntilLicenseExpires } = useAuthentication();
  const [show, setShow] = useState<boolean>(true);

  if (!showNagScreen || !show) return null;

  return (
    <Alert
      className="m-3"
      variant="warning"
      dismissible
      onClose={() => setShow(false)}
    >
      {`Your license will expire in ${daysUntilLicenseExpires} days`}
    </Alert>
  );
};

export default LicenseExpiryWarningNotification;
